import React, { useState, useEffect } from "react";
import styles from "./Gallery.module.css";

export default function Gallery() {
  const images = [`${process.env.PUBLIC_URL}/Images/image6.webp`, `${process.env.PUBLIC_URL}/Images/image7.webp`, `${process.env.PUBLIC_URL}/Images/image8.webp`];

  const [current, setCurrent] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // AUTOPLAY z zatrzymaniem przy hover
  useEffect(
    () => {
      if (isHovered) return;
      const interval = setInterval(() => {
        setCurrent(prev => (prev + 1) % images.length);
      }, 3500);
      return () => clearInterval(interval);
    },
    [isHovered, images.length]
  );

  const handleNext = () => setCurrent(prev => (prev + 1) % images.length);
  const handlePrev = () =>
    setCurrent(prev => (prev === 0 ? images.length - 1 : prev - 1));

  const getPositionStyle = index => {
    const total = images.length;
    const offset = (index - current + total) % total;

    let transform = "";
    let zIndex = 0;
    let opacity = 1;
    let filter = "none";

    if (offset === 0) {
      transform = "translateX(0) scale(1.05) rotateY(0deg)";
      zIndex = 3;
      filter = "brightness(1.1) saturate(1.1)";
    } else if (offset === 1) {
      transform = "translateX(200px) scale(0.85) rotateY(-18deg)";
      zIndex = 2;
      opacity = 0.9;
      filter = "brightness(0.6) grayscale(0.2)";
    } else if (offset === total - 1) {
      transform = "translateX(-200px) scale(0.85) rotateY(18deg)";
      zIndex = 2;
      opacity = 0.9;
      filter = "brightness(0.6) grayscale(0.2)";
    } else {
      transform = "translateX(0) scale(0.6)";
      opacity = 0;
      zIndex = 1;
      filter = "brightness(0.3) blur(2px)";
    }

    return { transform, zIndex, opacity, filter };
  };

  return (
    <div className="darkSectionContent" id="gallery">
      <div className="lightSectionTitle">
        <h1>Galeria</h1>
      </div>
      <div
        className={styles.galleryContainer}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <button className={styles.navButton} onClick={handlePrev}>
          &#10094;
        </button>

        <div className={styles.stackWrapper}>
          {images.map((src, index) =>
            <img
              key={index}
              src={src}
              alt={`Obraz ${index + 1}`}
              className={`${styles.imageCard} ${index === current
                ? styles.active
                : ""}`}
              style={getPositionStyle(index)}
            />
          )}
        </div>

        <button className={styles.navButton} onClick={handleNext}>
          &#10095;
        </button>
      </div>
    </div>
  );
}
